import { ReactNode } from 'react'

export const LoginContainer = (props: { children: ReactNode }) => {
  return (
    <section className="h-screen w-screen bg-gray-100">
      <div className="mx-auto flex h-screen flex-col items-center justify-center px-6 py-8 ">
        <div className="mx-auto h-fit w-96 rounded-lg bg-white px-6 pt-12 text-center">
          <div className="h-full">
            <div className="flex h-1/4 items-center justify-center py-4 text-center">
              <img className="h-auto w-1/2" src="/datable-logo.svg" alt="Datable" />
            </div>
            <div className={'h-1/2 items-center justify-center'}>{props.children}</div>
          </div>
        </div>
      </div>
    </section>
  )
}
